import { useContext } from "react";

import { CreateOrderContext, ICreateOrderContext } from "./CreateOrderContext";

export const useCreateOrder = (): ICreateOrderContext => {
    return useContext(CreateOrderContext);
};
